import request from '@/utils/request';

// 调解所有列表查询
export function getList(data, params) {
  return request({
    url: '/bak/mediation/list',
    method: 'post',
    data,
    params: params
  });
}

// 调解详情
export function getInfo(recordId) {
  return request({
    url: '/mediator/info/' + recordId,
    method: 'get'
  });
}

// 获取所有具有调解角色的用户
export function getMediatorRoleUsers(params) {
  return request({
    url: '/bak/mediation/getMediatorRoleUsers',
    method: 'get',
    params: params
  });
}

// 分配调解员
export function assign(data) {
  return request({
    url: '/bak/mediation/assign',
    method: 'post',
    data,
  });
}

// 调解预约
export function booking(data) {
  return request({
    url: '/bak/mediation/booking',
    method: 'post',
    data,
  });
}

// 调解进度
export function getProcess(recordId) {
  return request({
    url: '/mediation/getMediationProcess',
    method: 'get',
    params: {recordId}
  });
}
